/* eslint-disable prefer-destructuring */
/* eslint-disable no-return-assign */

'use-strict';

/* @ngInject */
export default function FuelFormController(
  $scope,
  toastService,
  $location,
  $routeParams,
  fuelApiService,
  dateService,
  interfaceService,
  numberConversionService,
) {
  $scope.newReceipt = false;
  $scope.receipt = null;

  const self = this;

  /**
   * Asks for receipts from server.
   * @param {Object} params (optional) specify which receipts to get.
   */
  const getReceipt = () => {
    fuelApiService.get($routeParams.receiptId)
      .then((receipt) => {
        // receipt.date = dateService.convertToFrontend(receipt.date);
        receipt.date = receipt.date;
        receipt.liter = numberConversionService.convertFloatToFrontend(receipt.liter);
        receipt.cost = numberConversionService.convertFloatToFrontend(receipt.cost);
        $scope.receipt = receipt; // Set first receipt in result for edit form
        interfaceService.applyScope($scope);
      })
      .catch((e) => console.error(e));
  };

  $scope.addEditFormSend = () => {
    if ($scope.newReceipt) return $scope.apiNewReceipt();
    return $scope.apiUpdateReceipt();
  };

  $scope.updateTableData = () => {
    self.table.settings({
      dataset: $scope.receipts,
    });
  };

  /**
   * Add a new receipt to the server.
   */
  $scope.apiNewReceipt = () => {
    const postData = {
      vehicleId: $scope.receipt.vehicleId,
      date: numberConversionService.frontendStringToDate($scope.receipt.date),
      liter: numberConversionService.convertFloatToBackend($scope.receipt.liter),
      cost: numberConversionService.convertFloatToBackend($scope.receipt.cost),
      mileage: $scope.receipt.mileage,
    };

    fuelApiService.post(postData)
      .then(() => {
        $scope.receipt = {
          car_id: $scope.receipt.car_id,
        };
        toastService.toast('success', 'Tankbeleg gespeichert.');
      })
      .catch((e) => console.error(e));
  };

  /**
   * Update an existing receipt on the server.
   */
  $scope.apiUpdateReceipt = () => {
    const postData = {
      id: $scope.receipt.id,
      vehicleId: $scope.receipt.vehicleId,
      date: numberConversionService.frontendStringToDate($scope.receipt.date),
      liter: numberConversionService.convertFloatToBackend($scope.receipt.liter),
      cost: numberConversionService.convertFloatToBackend($scope.receipt.cost),
      mileage: $scope.receipt.mileage,
    };

    fuelApiService.put(postData)
      .then(() => {
        $scope.receipt = {};
        $location.path('/sales/fuel/table');
        toastService.toast('success', 'Tankbeleg erfolgreich bearbeitet.');
      })
      .catch((e) => console.error(e));
  };

  /**
   * Remove the specified receipt from the server.
   * @param {string} receiptId.required
   */
  $scope.apiRemoveReceipt = (receiptId) => {
    fuelApiService.delete(receiptId)
      .then(() => {
        $location.path('/sales/fuel/table');
        toastService.toast('success', 'Tankbeleg erfolgreich gelöscht.');
      })
      .catch((e) => console.error(e));
  };

  const init = () => {
    if ($routeParams.receiptId === undefined) {
      $scope.newReceipt = true;
      $scope.receipt = {
        date: new Date(),
      };
    } else {
      getReceipt();
    }
  };

  init();
}
